import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { IControls } from 'bi-interfaces';
@Component({
  selector: 'bi-control-list',
  templateUrl: './bi-control-list.html',
  styleUrls: ['./bi-control-list.scss']
})
export class biControlListComponent implements OnChanges {

  @Input() controlList!: IControls[];
  @Input() formGroup!: FormGroup;
  @Input() noOfRows: number = 19;

  rowsList: string[] = [];

  public asFormControl(formControl: AbstractControl<any, any> | null): FormControl {
    return formControl as FormControl;
  }

  constructor() {
    this.fillRowsList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['noOfRows']) {
      this.noOfRows = changes['noOfRows'].currentValue;
      this.fillRowsList();
    }
  }

  fillRowsList() {
    this.rowsList = Array(this.noOfRows).fill('auto');
  }
}
